import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Menu, Settings2, X } from "lucide-react";
import ThemeToggle from "@/components/ThemeToggle";
import ConfigPanel from "@/pages/Dashboard/ConfigPanel";
import telegramLogo from "@/assets/telegram.svg";
import "@/pages/Dashboard/UserDashboard.css";

const exampleContents = [
  { id: "preview-1", type: "text" as const, text: "今天也来打卡了。" },
  { id: "preview-2", type: "text" as const, text: "记录一下今天的进度，明天继续。" },
  { id: "preview-3", type: "image" as const, imgUrl: "/images/preview-checkin.svg", text: "今天看到的风景。" },
];

const exampleGroups = [
  { chat_id: "preview-1", group_name: "每日打卡群" },
  { chat_id: "preview-2", group_name: "学习交流", consecutive_failures: 3 },
  { chat_id: "preview-3", group_name: "周末计划" },
];

const exampleSchedule = {
  use_time_range: true,
  interval_mode: "random" as const,
  start_time: "08:00",
  end_time: "22:00",
  interval_min: 25,
  interval_max: 35,
};

export default function ConfigPreviewPage() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="user-shell user-preview">
      {sidebarOpen && <button className="user-sidebar-backdrop" aria-label="关闭导航" onClick={() => setSidebarOpen(false)} />}
      <aside className={`user-sidebar ${sidebarOpen ? "is-open" : ""}`}>
        <div className="user-brand"><span className="user-brand-mark"><img src={telegramLogo} alt="" /></span><span><strong>TG Checkin</strong></span></div>
        <nav className="user-nav" aria-label="预览导航">
          <div className="user-nav-item is-active" aria-current="page"><Settings2 size={18} strokeWidth={1.9} /><span>打卡配置</span><span className="user-nav-indicator" /></div>
        </nav>
        <div className="user-sidebar-bottom"><Link to="/dashboard" className="user-sidebar-link"><ArrowLeft size={17} /> 返回个人中心</Link></div>
      </aside>

      <div className="user-workspace">
        <header className="user-topbar">
          <button className="user-menu-button" onClick={() => setSidebarOpen(!sidebarOpen)} aria-label={sidebarOpen ? "关闭导航" : "打开导航"}>{sidebarOpen ? <X size={21} /> : <Menu size={21} />}</button>
          <div className="user-breadcrumb"><span>界面预览</span><span className="user-breadcrumb-divider">/</span><strong>打卡配置</strong></div>
          <div className="user-topbar-actions"><span className="user-connection is-connected"><i />Telegram 模拟已连接</span><ThemeToggle /><span className="user-avatar">示</span></div>
        </header>
        <main className="user-main">
          <div className="user-page-heading"><h1>打卡配置</h1></div>
          <div className="user-preview-notice" role="note"><strong>界面预览</strong><span>这里展示的是示例内容和模拟连接状态。可以切换选项查看布局，但不会连接 Telegram，也不会保存任何修改。</span></div>
          <ConfigPanel contents={exampleContents} miscConfig={exampleSchedule} groups={exampleGroups} selectedGroups={["preview-1", "preview-2"]} refresh={() => {}} preview />
        </main>
      </div>
    </div>
  );
}
